import React from 'react';
import SettingsPage from './SettingsPage';

export default function OfficeContactBookPage() {
  return (
    <SettingsPage
      initialTab={1}
      forceTab={1}
      hideTabs
      hideTitle
      fixedProjectSettingsSection="contactsBook"
      hideProjectSettingsSections
    />
  );
}
